import React, { Component } from "react";

import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Divider from "@material-ui/core/Divider";
import FileCopyRounded from "@material-ui/icons/FileCopyRounded";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Refresh from "@material-ui/icons/Refresh";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import axios from "../../api/axios-allure-docker";
import AllureDockerReportsDropDown from "../../components/AllureDockerReportsDropDown/AllureDockerReportsDropDown";
import AllureDockerDeleteProjectDialog from "../../components/AllureDockerDeleteProjectDialog/AllureDockerDeleteProjectDialog";
import AllureDockerMoveProjectDialog from "../../components/AllureDockerMoveProjectDialog/AllureDockerMoveProjectDialog";
import AllureDockerGenerateReport from "../../components/AllureDockerGenerateReportDialog/AllureDockerGenerateReportDialog";
import AllureDockerCleanResultsDialog from "../../components/AllureDockerCleanResultsDialog/AllureDockerCleanResultsDialog";
import AllureDockerCleanHistoryDialog from "../../components/AllureDockerCleanHistoryDialog/AllureDockerCleanHistoryDialog";
import AllureDockerSendResultsDialog from "../../components/AllureDockerSendResultsDialog/AllureDockerSendResultsDialog";
import { redirect, redirectRootInSeconds } from "../../utility/navigate";
import { isAdmin } from "../../utility/user-actions";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  breadcrumb: {
    display: "flex",
    alignItems: "baseline",
    flexWrap: "wrap",
    marginBottom: theme.spacing(3),
  },
  breadcrumbGroup: {
    color: theme.palette.text.disabled,
    fontSize: 13,
  },
  breadcrumbSeparator: {
    color: theme.palette.divider,
    margin: theme.spacing(0, 0.75),
  },
  actions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "& > *": { marginRight: theme.spacing(1) },
    marginBottom: theme.spacing(2),
  },
  reportPanel: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  // Полоска-«окно» помечает границу: дальше начинается чужой HTML, который мы
  // не стилизуем (iframe кросс-доменный — ни высоту подобрать, ни CSS вложить).
  reportChrome: {
    display: "flex",
    alignItems: "center",
    height: 36,
    padding: theme.spacing(0, 1.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor:
      theme.palette.type === "dark" ? "#0a0a0a" : theme.palette.background.default,
  },
  reportChromeDots: {
    display: "flex",
    "& > * + *": { marginLeft: 6 },
  },
  reportChromeDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    border: `1px solid ${theme.palette.divider}`,
  },
  reportChromeLabel: {
    flexGrow: 1,
    textAlign: "center",
    color: theme.palette.text.disabled,
    fontSize: 11,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  // Стык впритык: чёрный зазор вокруг белого отчёта выглядит как поломка,
  // жёсткая граница — как решение.
  cardMedia: {
    height: "calc(100vh - 260px)",
    minHeight: 640,
    display: "block",
    border: "none",
  },
  // Повторяет classes.empty с главной, чтобы два пустых состояния читались
  // как одна семья: пунктирная волосяная рамка, радиус 8, надзаголовок.
  emptyPanel: {
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: 8,
    padding: theme.spacing(6),
    textAlign: "center",
  },
  emptyEyebrow: {
    color: theme.palette.text.disabled,
    display: "block",
    marginBottom: theme.spacing(1),
  },
  emptyText: {
    color: theme.palette.text.secondary,
    maxWidth: "60ch",
    margin: "0 auto",
    fontSize: 15,
  },
  emptyHint: {
    color: theme.palette.text.disabled,
    display: "block",
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  progressPanel: {
    width: 280,
    textAlign: "center",
  },
  progressLabel: {
    color: theme.palette.text.disabled,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    marginBottom: theme.spacing(1.5),
  },
  progressBar: {
    height: 2,
  },
});

class AllureDockerProject extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  get initialState() {
    return {
      project: null,
      projectNotFound: false,
      progress: false,
      reportSelected: null,
      reportSelectedValue: 0,
      reportUrlSelected: null,
      openDeleteProjectDialog: false,
      openMoveProjectDialog: false,
      openGenerateReportDialog: false,
      openCleanResultsDialog: false,
      openCleanHistoryDialog: false,
      openSendResultsDialog: false,
      openCopyToolTip: false,
      actionsAnchorEl: null,
    };
  }

  componentDidMount() {
    this.getProject(this.props.match.params.id);
  }

  componentDidUpdate() {
    if (this.props.match.params.id) {
      if (
        !this.state.project ||
        (this.state.project &&
          this.state.project.id !== this.props.match.params.id)
      ) {
        this.getProject(this.props.match.params.id);
      }
    }
  }

  getProject = (projectId) => {
    axios
      .get(`/projects/${projectId}`)
      .then((response) => {
        // проект успели переключить — ответ по покинутому id молча отбрасываем
        if (projectId !== this.props.match.params.id) {
          return;
        }
        this.setState({
          project: response.data.data.project,
          reportSelected: null,
          reportSelectedValue: 0,
          reportUrlSelected: null,
          projectNotFound: false,
        });
      })
      .catch((error) => {
        if (projectId !== this.props.match.params.id) {
          return;
        }
        redirect(error);

        let projectNotFound = false;
        if (error.status === 404) {
          projectNotFound = true;
        }
        this.handleAPIErrorAlert(error);
        const project = { ...this.state.project };
        project.id = projectId;
        project.reports = [];
        this.setState({ project: project, projectNotFound: projectNotFound });
        redirectRootInSeconds(3);
      });
  };

  goToEmailableReport = (projectId) => {
    if (projectId) {
      axios
        .get(`/emailable-report/render?project_id=${projectId}`, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/html" })
          );
          window.open(url, "_blank");
          this.handleAPISuccessAlert("Report successfully rendered");
        })
        .catch((error) => {
          redirect(error);
          this.handleAPIErrorAlert(error);
        });
    }
  };

  exportEmailableReport = (projectId) => {
    axios
      .get(`/emailable-report/export?project_id=${projectId}`, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "text/html" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = `${projectId}-emailable-report-allure-docker-service.html`;
        link.click();
        this.handleAPISuccessAlert("Emailable Report successfully exported");
      })
      .catch((error) => {
        redirect(error);
        this.handleAPIErrorAlert(error);
      });
  };

  exportFullReport = (projectId) => {
    axios
      .get(`/report/export?project_id=${projectId}`, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/zip" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = `${projectId}-allure-docker-service-report.zip`;
        link.click();
        this.handleAPISuccessAlert("Full Report successfully exported");
      })
      .catch((error) => {
        redirect(error);
        this.handleAPIErrorAlert(error);
      });
  };

  refreshProject = () => {
    this.setState(this.initialState);
  };

  copyReportUrl = (reportUrlSelected) => {
    if(reportUrlSelected) {
      navigator.clipboard.writeText(reportUrlSelected);
      this.openCopyToolTip();
    }
  };

  goToReport = (reportUrlSelected) => {
    if (reportUrlSelected) {
      window.open(reportUrlSelected, "_blank");
    }
  };

  showProgress = (show) => {
    this.setState({ progress: show });
  };

  handleAPISuccessAlert = (message) => {
    this.props.setAPIAlert("success", message, true);
  };

  handleAPIErrorAlert = (error) => {
    this.props.setAPIAlert(
      "error",
      `Something wrong => ${error.message}`,
      true
    );
  };

  openDeleteProjectDialog = () => {
    this.setState({ openDeleteProjectDialog: true });
  };

  closeDeleteProjectDialog = () => {
    this.setState({ openDeleteProjectDialog: false });
  };

  openActionsMenu = (event) => {
    this.setState({ actionsAnchorEl: event.currentTarget });
  };

  closeActionsMenu = () => {
    this.setState({ actionsAnchorEl: null });
  };

  runFromMenu = (action) => () => {
    this.closeActionsMenu();
    action();
  };

  openMoveProjectDialog = () => {
    this.setState({ openMoveProjectDialog: true });
  };

  closeMoveProjectDialog = () => {
    this.setState({ openMoveProjectDialog: false });
  };

  openGenerateReportDialog = () => {
    this.setState({ openGenerateReportDialog: true });
  };

  closeGenerateReportDialog = () => {
    this.setState({ openGenerateReportDialog: false });
  };

  openCleanResultsDialog = () => {
    this.setState({ openCleanResultsDialog: true });
  };

  closeCleanResultsDialog = () => {
    this.setState({ openCleanResultsDialog: false });
  };

  openCleanHistoryDialog = () => {
    this.setState({ openCleanHistoryDialog: true });
  };

  closeCleanHistoryDialog = () => {
    this.setState({ openCleanHistoryDialog: false });
  };

  openSendResultsDialog = () => {
    this.setState({ openSendResultsDialog: true });
  };

  closeSendResultsDialog = () => {
    this.setState({ openSendResultsDialog: false });
  };

  openCopyToolTip = () => {
    this.setState({ openCopyToolTip: true });
  };

  closeCopyToolTip = () => {
    this.setState({ openCopyToolTip: false });
  };

  buildReportIPath = (projectId, reportId) => {
    return `/projects/${projectId}/reports/${reportId}/index.html?redirect=false`;
  };

  // URL строится из значения опции, а НЕ читается из её текста. Раньше текст и
  // был URL — та же строка служила подписью в селекте и содержимым буфера
  // обмена. Как только подпись стала человекочитаемой ("latest", "#1"),
  // прежнее чтение скопировало бы в буфер слово "latest".
  buildReportUrl = (reportId) => `${window.location.href}/reports/${reportId}`;

  selectReport = (event, projectId) => {
    const reportSelectedValue = event.target.value;
    const reportUrlSelected = this.buildReportUrl(reportSelectedValue);
    const reportPath = this.buildReportIPath(projectId, reportSelectedValue);

    axios
      .get(reportPath)
      .then((response) => {
        this.setState({
          reportSelectedValue: reportSelectedValue,
          reportSelected: `${window._env_.ALLURE_DOCKER_API_URL}${reportPath}`,
          reportUrlSelected: reportUrlSelected,
        });
      })
      .catch((error) => {
        redirect(error);
        this.handleAPIErrorAlert(error);
      });
  };

  render() {
    const { classes } = this.props;
    let projectId = "";
    let reports = [];
    let reportIframe = "";
    let reportSelectedValue = "";
    let reportUrlSelected = "";

    // Три явных состояния вместо одного безусловного рендера: раньше проект без
    // отчётов показывал пустой селект, две мёртвые кнопки и 640px чёрного
    // iframe — читалось как поломка, хотя это первое, что видит человек сразу
    // после создания проекта.
    const isLoading = this.state.project === null;
    const isProjectMissing = this.state.projectNotFound;
    const hasReports = !isLoading && (this.state.project.reports || []).length > 0;

    if (this.state.project) {
      const project = this.state.project;
      projectId = project.id;
      if (project.reports.length !== 0) {
        for (let i in project.reports) {
          const reportId = project.reports_id[i];
          reports.push({
            linkValue: reportId,
            // Подпись и URL — разные вещи: в селекте шириной 295px полный URL
            // обрезался, и отчёты были неразличимы.
            label: reportId === "latest" ? "latest" : `#${reportId}`,
            url: this.buildReportUrl(reportId),
          });
        }
        const reportPath = this.buildReportIPath(
          projectId,
          reports[0].linkValue
        );
        reportIframe = `${window._env_.ALLURE_DOCKER_API_URL}${reportPath}`;
        reportSelectedValue = reports[0].linkValue;
        reportUrlSelected = reports[0].url;

        if (
          this.state.reportSelected &&
          this.state.reportSelected !== reportIframe
        ) {
          reportIframe = this.state.reportSelected;
          reportSelectedValue = this.state.reportSelectedValue;
        }

        if (this.state.reportUrlSelected) {
          reportUrlSelected = this.state.reportUrlSelected;
        }
      }
    }

    let progress = "";
    if (this.state.progress) {
      progress = (
        // Спиннер — самый безликий объект интерфейса; полоса плюс надпись
        // хотя бы говорят, что именно происходит.
        <Backdrop open={true} className={classes.backdrop}>
          <div className={classes.progressPanel}>
            <div className={classes.progressLabel}>Analyzing</div>
            <LinearProgress className={classes.progressBar} />
          </div>
        </Backdrop>
      );
    }

    // Условие видимости действий сохранено дословно: перепутать его — значит
    // молча отобрать у админов все операции над проектом.
    const areProjectActionsAvailable =
      !reportSelectedValue || reportSelectedValue === "latest" || reports.length === 0;

    // Гейтим ПОТРЕБИТЕЛЕЙ, а не само выражение выше: для несуществующего
    // проекта areProjectActionsAvailable истинно (reports.length === 0), и
    // Send Results / Generate Report / весь экспорт рендерились бы, хотя
    // каждый из них ушёл бы в 404.
    const inlineActions = areProjectActionsAvailable && !isProjectMissing ? (
      <React.Fragment>
        <Button
          variant="contained"
          color="primary"
          onClick={this.openSendResultsDialog}
          disabled={!isAdmin()}
        >
          Send Results
        </Button>
        <Button
          variant="outlined"
          onClick={this.openGenerateReportDialog}
          disabled={!isAdmin()}
        >
          Generate Report
        </Button>
      </React.Fragment>
    ) : null;

    // Восемь contained-кнопок подряд — примерно 1100px сплошного индиго, и
    // Delete Project стоял ПЕРВЫМ, вплотную к Send Results. Разрушительное
    // действие уезжает вниз меню, за собственный разделитель, в красный.
    const menuItems = [];
    if (areProjectActionsAvailable && !isProjectMissing) {
      menuItems.push(
        <MenuItem key="get-emailable" onClick={this.runFromMenu(() => this.goToEmailableReport(projectId))}>
          Get Emailable Report
        </MenuItem>,
        <MenuItem key="export-emailable" onClick={this.runFromMenu(() => this.exportEmailableReport(projectId))}>
          Export Emailable Report
        </MenuItem>,
        <MenuItem key="export-full" onClick={this.runFromMenu(() => this.exportFullReport(projectId))}>
          Export Full Report
        </MenuItem>,
        <Divider key="divider-danger" />,
        <MenuItem key="clean-results" onClick={this.runFromMenu(this.openCleanResultsDialog)} disabled={!isAdmin()}>
          Clean Results
        </MenuItem>,
        <MenuItem key="clean-history" onClick={this.runFromMenu(this.openCleanHistoryDialog)} disabled={!isAdmin()}>
          Clean History
        </MenuItem>
      );
    }
    if (!this.state.projectNotFound) {
      menuItems.push(
        <MenuItem key="move" onClick={this.runFromMenu(this.openMoveProjectDialog)} disabled={!isAdmin()}>
          Move Project
        </MenuItem>,
        <Divider key="divider-delete" />,
        <MenuItem
          key="delete"
          onClick={this.runFromMenu(this.openDeleteProjectDialog)}
          disabled={!isAdmin()}
          style={{ color: this.props.theme.palette.error.main }}
        >
          Delete Project
        </MenuItem>
      );
    }

    const buttonsGroup = (
      <div className={classes.actions}>
        {inlineActions}
        {menuItems.length > 0 && (
          <React.Fragment>
            <IconButton aria-label="more actions" onClick={this.openActionsMenu}>
              <MoreHorizIcon />
            </IconButton>
            <Menu
              anchorEl={this.state.actionsAnchorEl}
              open={Boolean(this.state.actionsAnchorEl)}
              onClose={this.closeActionsMenu}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              {menuItems}
            </Menu>
          </React.Fragment>
        )}
      </div>
    );

    // Имя проекта и его папка — разные вещи: id плоский, папка приходит полем
    // `folder` из GET /projects/{id}. Раньше id был путём и крошки резались из него.
    const projectFolder = (this.state.project && this.state.project.folder) || "";
    const projectGroups = projectFolder ? projectFolder.split("/") : [];

    // Grid container spacing={8} давал отрицательные внешние поля и съедал
    // паддинг <main>: контент прилипал к левому краю.
    return (
      <div className={classes.root}>
              <div className={classes.breadcrumb}>
                {projectGroups.map((segment, index) => (
                  <React.Fragment key={`${segment}-${index}`}>
                    <span className={classes.breadcrumbGroup}>{segment}</span>
                    <span className={classes.breadcrumbSeparator}>/</span>
                  </React.Fragment>
                ))}
                <Typography variant="h4" component="h1">
                  {projectId}
                </Typography>
              </div>
              <div align="center">{progress}</div>
              <div>
                {/* Селект, копирование и полноэкранный режим без отчётов
                    показывать нечего: селект был бы пустым, а два обработчика
                    молча возвращались бы на пустой строке. Refresh остаётся —
                    это честный повтор запроса. */}
                {hasReports && (
                  <AllureDockerReportsDropDown
                    selectReport={(event) => this.selectReport(event, projectId)}
                    reportSelected={reportSelectedValue}
                    reports={reports}
                  />
                )}
                {!isLoading && (
                <Button
                  key="refresh"
                  aria-label="refresh project"
                  onClick={this.refreshProject}
                >
                  <Refresh />
                </Button>
                )}

                {hasReports && (
                <ClickAwayListener onClickAway={this.closeCopyToolTip}>
                  <Tooltip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    onClose={this.closeCopyToolTip}
                    open={this.state.openCopyToolTip}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title="URL copied"
                    placement="top"
                  >
                    {/* aria-label не конфликтует с «URL copied»: у этого
                        Tooltip отключены все три слушателя, поэтому native
                        title он не пишет и даёт только aria-describedby. */}
                    <Button
                      key="file-copy"
                      aria-label="copy report URL"
                      onClick={() => this.copyReportUrl(reportUrlSelected)}
                    >
                      <FileCopyRounded />
                    </Button>
                  </Tooltip>
                </ClickAwayListener>
                )}
                {/* Иконка говорит «на весь экран», а обработчик открывает
                    новую вкладку — подписываем поведение, а не глиф. */}
                {hasReports && (
                <Button
                  key="go-to"
                  aria-label="open report in a new tab"
                  onClick={() => this.goToReport(reportUrlSelected)}
                >
                  <FullscreenIcon />
                </Button>
                )}
              </div>
              <div>
                {buttonsGroup}
                <AllureDockerDeleteProjectDialog
                  projectId={this.props.match.params.id}
                  open={this.state.openDeleteProjectDialog}
                  handleCloseDialog={this.closeDeleteProjectDialog}
                  setAPIAlert={this.props.setAPIAlert}
                  getProjects={this.props.getProjects}
                  showProgress={this.showProgress}
                />
                <AllureDockerMoveProjectDialog
                  projectId={this.props.match.params.id}
                  currentFolder={projectFolder}
                  folders={this.props.folders}
                  open={this.state.openMoveProjectDialog}
                  handleCloseDialog={this.closeMoveProjectDialog}
                  moveProject={this.props.moveProject}
                />
                <AllureDockerSendResultsDialog
                  projectId={this.props.match.params.id}
                  open={this.state.openSendResultsDialog}
                  handleCloseDialog={this.closeSendResultsDialog}
                  setAPIAlert={this.props.setAPIAlert}
                  getProjects={this.props.getProjects}
                  refreshProject={this.refreshProject}
                  showProgress={this.showProgress}
                />
                <AllureDockerGenerateReport
                  projectId={this.props.match.params.id}
                  open={this.state.openGenerateReportDialog}
                  handleCloseDialog={this.closeGenerateReportDialog}
                  setAPIAlert={this.props.setAPIAlert}
                  getProjects={this.props.getProjects}
                  refreshProject={this.refreshProject}
                  showProgress={this.showProgress}
                />
                <AllureDockerCleanResultsDialog
                  projectId={this.props.match.params.id}
                  open={this.state.openCleanResultsDialog}
                  handleCloseDialog={this.closeCleanResultsDialog}
                  setAPIAlert={this.props.setAPIAlert}
                  getProjects={this.props.getProjects}
                  refreshProject={this.refreshProject}
                  showProgress={this.showProgress}
                />
                <AllureDockerCleanHistoryDialog
                  projectId={this.props.match.params.id}
                  open={this.state.openCleanHistoryDialog}
                  handleCloseDialog={this.closeCleanHistoryDialog}
                  setAPIAlert={this.props.setAPIAlert}
                  getProjects={this.props.getProjects}
                  refreshProject={this.refreshProject}
                  showProgress={this.showProgress}
                />
                {/* Пока проект грузится, панель не рендерим вовсе: раньше на
                    каждом открытии мигал чёрный iframe до ответа API. */}
                {hasReports && (
                  <Card className={classes.reportPanel}>
                    <div className={classes.reportChrome}>
                      <div className={classes.reportChromeDots}>
                        <span className={classes.reportChromeDot} />
                        <span className={classes.reportChromeDot} />
                        <span className={classes.reportChromeDot} />
                      </div>
                      <div className={classes.reportChromeLabel}>
                        {projectId} · {reportSelectedValue || "latest"}
                      </div>
                      <div style={{ width: 34 }} />
                    </div>
                    <CardMedia
                      className={classes.cardMedia}
                      component="iframe"
                      image={reportIframe}
                      title="Allure Report"
                    ></CardMedia>
                  </Card>
                )}

                {isProjectMissing && (
                  <div className={classes.emptyPanel}>
                    <Typography variant="overline" className={classes.emptyEyebrow}>
                      Not found
                    </Typography>
                    <Typography className={classes.emptyText}>
                      Project <code>{projectId}</code> does not exist. Returning to the
                      project list…
                    </Typography>
                  </div>
                )}

                {!isLoading && !isProjectMissing && !hasReports && (
                  <div className={classes.emptyPanel}>
                    <Typography variant="overline" className={classes.emptyEyebrow}>
                      No reports
                    </Typography>
                    <Typography className={classes.emptyText}>
                      Nothing has been reported for this project yet. Send{" "}
                      <code>allure-results</code> from your pipeline —{" "}
                      <code>POST /send-results</code> with{" "}
                      <code>project_id={projectId}</code> — then generate a report. New
                      reports show up here automatically.
                    </Typography>
                    <Typography variant="caption" className={classes.emptyHint}>
                      Admins can do both from the buttons above.
                    </Typography>
                  </div>
                )}
              </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(AllureDockerProject)
);
